import { useState, useEffect } from "react";
import { Box, Button, CardMedia, Card, TextField } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import Detail from "../../../main/detail/Detail";
import { rsActiveMenu, rsProgress, rsParentCom } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseHomeLanding } from "./UseHomeLanding";
import { FileUploader } from "react-drag-drop-files";
import useBreakpoints from "../../../hooks/useBreakpoints";

export default function EditLandItem(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const location = useLocation();
  const [msParentCom, setMsParentCom] = useRecoilState(rsParentCom);
  const navigate = useNavigate();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const fileTypes = [
    "JPG",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "PNG",
    "SVG",
    "webp",
    "GIF",
  ];
  const { validateItem, updateLandingItem } = UseHomeLanding();
  const [items, setItems] = useState();
  const { isSmall } = useBreakpoints();
  const [state, setState] = useState({
    id: undefined,
    landingID: undefined,
    url: undefined,
    title: undefined,
    description: undefined,
    rowIndex: undefined,
  });

  const [imgState, setImgState] = useState({
    file: "",
    url: state.icon ? state.icon : "",
  });

  useEffect(() => {
    if (location.state.row) {
      setState({
        id: location.state.row.id,
        landingID: location.state.row.landingID,
        url: location.state.row.url,
        title: location.state.row.title
          ? location.state.row.title
          : "بدون عنوان",
        description: location.state.row.description,
        rowIndex: location.state.row.rowIndex,
      });
      setItems(location.state.row.items);
      setImgState({
        file: undefined,
        url: location.state.row.image ? location.state.row.image : "",
      });
    }
  }, [location.state.row]);

  const [errorState, setErrorState] = useState({
    title: false,
  });

  const handleChangeImage = (file) => {
    setImgState({
      file: file[0],
      url: URL.createObjectURL(file[0]),
    });
  };

  return (
    <Detail
      breadChilds={{
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: msParentCom.parentComs },
          {
            name: "مدیریت" + " " + location.state.componentFaTitle,
            url: "/LandingsManage",
            LandingID: location.state.LandingID && location.state.LandingID,
            componentFaTitle: location.state.componentFaTitle,
          },
          {
            name: location.state.backName,
            url: location.state.backUrl,
            LandingID: location.state.LandingID && location.state.LandingID,
            LanID: location.state.LanID && location.state.LanID,
          },
          {
            name: "ویرایش آیتم",
            url: "/LandingsManage/editItem",
          },
        ],
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
          <Box gridColumn={isSmall ? "span 12" : "span  4"}>
            <TextField
              fullWidth
              value={state.title ? state.title : ""}
              error={errorState.title}
              label="عنوان"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, title: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 8"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span  6"}>
            <TextField
              fullWidth
              value={state.url ? state.url : ""}
              error={errorState.url}
              label="آدرس"
              sx={{
                textarea: {
                  direction: "rtl",
                },
              }}
              multiline
              rows={2}
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, url: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 6"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span  6"}>
            <TextField
              fullWidth
              value={state.description ? state.description : ""}
              label="توضیحات"
              multiline
              rows={2}
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, description: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 6"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span  3"}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: 5,
            }}
          >
            <FileUploader
              multiple={true}
              handleChange={(evt) => handleChangeImage(evt)}
              name="file"
              types={fileTypes}
              children={
                <Box sx={{ width: "170px", height: "auto" }}>
                  <Card
                    sx={{
                      p: 1,
                      border: "1px",
                      borderStyle: "dashed",
                      borderColor: "secondary.main",
                      borderRadius: 4,
                      boxShadow: 0,
                      cursor: "pointer",
                    }}
                  >
                    <CardMedia
                      component="img"
                      sx={{ width: "100%", height: "100%" }}
                      image={
                        imgState.url
                          ? imgState.url
                          : "/static/img/no-photos.png"
                      }
                    />
                  </Card>
                </Box>
              }
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}

          <Box
            gridColumn={isSmall ? "span 12" : "span  6"}
            sx={{ my: 2, display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              onClick={() => {
                if (validateItem(state, setErrorState) == 200) {
                  setProgress(true);
                  updateLandingItem(state, imgState.file, (calback) => {
                    navigate(location.state.backUrl, {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate(location.state.backUrl, {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      </Box>
    </Detail>
  );
}
